export default {
  system: {
    systemName: 'G-EDI Platform - Admin',
    logOut: 'Log Out',
    profile: 'profile'
  },
  route: {
    mdCodeTypeDefaultManage: 'mdCodeTypeDefaultManage',
    staffManagement: 'staffManagement',
    InvoiceQuery: 'InvoiceQuery',
    sysRoleManage: 'sysRoleManage',
    HistoryEdit: 'HistoryEdit',
    BillDetail: 'BillDetail',
    orderInvoiceDetails: 'orderInvoiceDetails',
    overseasWelcome: 'overseasWelcome',
    ILPWMS: 'ILPWMS',
    dashboard: 'Dashboard',
    documentation: 'Documentation',
    guide: 'Guide',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    rolePermission: 'Role Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    dndList: 'Dnd List',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: 'Mixin',
    backToTop: 'Back To Top',
    dragDialog: 'Drag Dialog',
    dragSelect: 'Drag Select',
    dragKanban: 'Drag Kanban',
    charts: 'Charts',
    keyboardChart: 'Keyboard Chart',
    lineChart: 'Line Chart',
    mixChart: 'Mix Chart',
    example: 'Example',
    Table: 'Table',
    dynamicTable: 'Dynamic Table',
    dragTable: 'Drag Table',
    inlineEditTable: 'Inline Edit',
    complexTable: 'Complex Table',
    componentTable: 'Component Table',
    tab: 'Tab',
    form: 'Form',
    createArticle: 'Create Article',
    editArticle: 'Edit Article',
    articleList: 'Article List',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    mergeHeader: 'Merge Header',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboardDemo: 'Clipboard',
    i18n: 'I18n',
    ediSetting: 'EDI Setting',
    ediApp: 'EDI App',
    ediType: 'EDI Type',
    ediCodeType: 'EDI Code Type',
    ediInteraction: 'EDI Interaction',
    codeConversion: 'Code Conversion',
    demo: 'demo',
    messageDefinition: 'Message Definition',
    referenceConfiguration: 'Reference Configuration',
    configTransform: 'Config Transform',
    configAuth: 'Config Auth',
    downloadSetting: 'Download Setting',
    // query: 'Query',
    searchTrack: 'Search Track',
    searchReceipt: 'Search Receipt',
    searchException: 'Search Exception',
    searchLog: 'Search Log',
    monitor: 'Monitor',
    monitorImport: 'Monitor Import',
    monitorExport: 'Monitor Export',
    alarm: 'Alarm',
    alarmRule: 'Alarm Rule',
    alarmEvent: 'Alarm Event',
    alarmResult: 'Alarm Result',
    messageManage: 'Message Manage',
    booking: 'Booking Manage',
    bookingAdd: 'Booking Add',
    bookingEdit: 'Booking Edit',
    bookingEdi: 'EDI Booking',
    bookingManage: 'Booking Manage',
    bookingTemplateManagement: 'Booking Template Management',
    VGMAdd: 'VGM Add',
    VGMManage: 'VGM Manage',
    VGMEdit: 'VGM Edit',
    manifest: 'Manifest Management',
    manifestManagement: 'Manifest Management',
    manifestAdd: 'Manifest Add',
    manifestEdi: 'EDI Manifest',
    ladingbill: 'Lading Bill Management',
    ladingbillManagement: 'Lading Bill Management',
    ladingbillEdi: 'EDI Lading Bill',
    ladingbillEdit: 'Lading Bill Edit',
    onlineOrderMatching: 'Online Order Matching',
    overseasagency: 'Overseas Agency',
    DsrQuery: 'Dsr Query',
    AppointmentCheck: 'Appointment Check',
    AdvanceDelivery: 'Advance Delivery',
    BoxInformationQuery: 'Box Information Query',
    query: 'Query',
    Invoice: 'Invoice',
    InvoiceDetail: 'Invoice Detail',
    ShippingDate: 'Shipping Date',
    StatusHistory: 'Status History',
    Bill: 'Bill',
    ShipSchedule: 'Ship Schedule',
    ServiceConsultation: 'Service Consultation',
    MessageSubscription: 'Message Subscription',
    system: 'System Management',
    OpenOnlineService: 'Open Online Service',
    Maintenance: 'Maintenance',
    UserManagement: 'User Management',
    PermissionConfiguration: 'Permission Configuration',
    UserMaintain: 'User Maintain',
    UserEdit: 'User Edit'
  },
  navbar: {
    dashboard: 'Dashboard',
    switch: 'Change Role',
    logOut: 'Log Out',
    changePassword: ' Change Password',
    theme: 'Theme',
    size: 'Global Size',
    refresh: 'Refresh',
    fullscreen: 'Fullscreen',
    langSelect: 'Lang Select',
    zh: '中文',
    en: 'English',
    message: 'Notification Center',
    messageDetail: ' unread'
  },
  login: {
    home: 'Home',
    forgetpassword: 'Forget the password',
    rememberPassword:"Remember the password",
    register: 'Owner user registration',
    title: 'Login Form',
    booking: 'booking',
    bookingQuery : 'bookingQuery',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  home: {
    booking: 'booking',
    bookingQuery : 'bookingQuery',
    serviceInformation: 'Service',
    complaintsAndSuggestions: 'Suggestions',
    adminLogin: 'Admin login',
    login: 'Login',
    title:'Customer Online Services',
    ctsCr: 'CTS International Logistics Corporation LimitedCopyright Reserved Shanghai',
    dvCr: '上海德祥国际货运代理有限公司',
    glCr:'Tech Support：Gillion New Software Co., Ltd',
    cargoTracking: "Cargo Tracking",
    PublicSecurityRN: '沪公网安备 31011302007008号',
    ICPRN: '沪ICP备14044727号-3',
    customerServiceTel: 'Customer service Hotline:4001-223-591',
  },
  permission: {
    addRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    tagsView: 'Open Tags-View',
    fixedHeader: 'Fixed Header',
    sidebarLogo: 'Sidebar Logo'
  },
  button: {
    addARole: 'Add a role',
    removeARole: 'Remove a role',
    resetPassword: 'Reset password',
    addUser: 'addUser',
    deleteUser: 'deleteUser',
    takeEffect: 'take effect',
    loseEfficacy: 'lose efficacy',
    signIn: 'Sign In',
    startSearching: 'Search',
    query: 'Query',
    querying: 'Querying',
    reset: 'Reset',
    add: 'Add',
    batchSave: 'Batch Save',
    batchSaving: 'batch Saving',
    batchDelete: 'Batch Delete',
    delete: 'Delete',
    pause: 'Pause',
    start: 'Enable',
    starting: 'Enabling',
    save: 'Save',
    saving: 'Saving',
    submit: 'Submit',
    submitting: 'Submitting',
    submitReview: 'submit Review',
    submitReviewing: 'submit Reviewing',
    copy: 'Copy',
    confirm: 'Confirm',
    close: 'Close',
    preview: 'Preview'
  },
  table: {
    userRole: 'User role',
    customerName: 'Customer name',
    entryTime: 'Entry time',
    validMark: 'Valid mark',
    dataScope: 'Data scope',
    orderSource: 'order source',
    loginAccount: 'Login account',
    chineseName: 'Chinese name',
    englishName: 'English name',
    eMailAddress: 'E-mail address',
    telephoneNumber: 'Telephone number',
    dataPermission: 'Data permission',
    effective: 'effective',
    roleName: 'roleName',
    OwningRegion: 'Owning region',
    affiliatedCompany: 'Affiliated company',
    valid: 'valid',
    effectiveTime: 'Effective time',
    failureTime: 'Failure time',
    sex: 'sex',
    mobilePhone: 'Telephone number',
    officeTelephone: 'Office telephone',
    fax: 'fax',
    qqNumber: 'qqNumber',
    wechatNumber: 'Wechat Number',
    identityCardNo: 'identityCardNo',

    remark: 'Remark',
    creatorName: 'Creator',
    createTime: 'Create Time',
    lastModifierName: 'Last Modifier',
    lastModifyTime: 'Last Modify Time',
    settleOfficeName: 'Settle Company',
    settleOfficeCode: 'Settle Company Code',
    redStar: '<label style=\'color:red\'>*</label>',
    select: 'Please select',
    to: 'To',
    startTime: 'Start Time',
    endTime: 'End Time',
    saleCode: 'Sale Code',
    saleName: 'Sale Name',
    salePersonCode: 'Sale Person Code',
    salePersonName: 'Sale Person Name',
    inoperable: 'Inoperable',
    custCode: 'Consignor Code',
    custName: 'Consignor Name',
    custShortName: 'Consignor Short Name',
    rememberNo: 'Remember No',
    audited: 'Audited',
    notAudited: 'Not Audited',
    theRecentWeek: 'recent week',
    theRecentMonth: 'recent month',
    theRecentThreeMonths: 'recent three months',
    today: 'Today',
    yesterday: 'yesterday',
    aWeekAgo: 'A week ago',
    code: 'Unit Code',
    name: 'Unit Name',
    templateCode: 'Template Code',
    templateName: 'Template Name',
    taxRate: 'Tax Rate',
    codeValue: 'Column Code',
    displayValueCn: 'Column Chinese',
    displayValueEN: 'Column English',
    fileName: 'File Name',
    selectTime: 'select Time',
    pleaseSelect: 'please Select',
    pleaseEnterEnglish: 'please Enter English',
    pleaseEnter: 'please Enter',
    noInformation: 'No shipping company extension information is available',
  },
  // 校验
  rule: {
    notNull: 'Cannot be null',
    richLength20: 'Length cannot exceed 20',
    richLength50: 'Length cannot exceed 50',
    maxNotLessThanMin: 'The maximum value cannot be less than the minimum value',
    EnglishAndNumbers: 'Only English and numbers can be input'
  },
  // 提示信息
  message: {
    PleaseCheckARecord: 'Please check a record',
    effectiveSuccess: 'Effective success',
    cannotTakeEffectAgain: 'The user is an effective user and cannot take effect again',
    failureSuccess: 'Failure success',
    cannotTakeInvalidAgain: 'The user is invalid and cannot be invalid again',
    enterTheRequiredFields: 'Please enter the required fields',
    saveTheUserFirst: 'Please save the user first',
    selectOneRecordToDelete: 'Please select at least one record to delete!',
    selectOneRecordToTakeEffect: 'Please select at least one record to take effect!',
    selectOneRecordToLoseEfficacy: 'Please select at least one record to lose efficacy!',
    HaveComeIntoEffect: 'Have come into effect',
    Expired: 'Expired',
    selectAnInactiveRecord: 'Please select an inactive record!',
    selectAnInUnexpiredRecord: 'Please select an unexpired record!',
    cannotBeDeleted: 'Some valid users exist and cannot be deleted!',

    location: 'Failed to get location!',
    noUnsavedData: 'There is no unsaved data',
    batchSaveFailed: 'Batch save failed',
    batchSaveSuccessful: 'Batch save successful',
    batchDeleteFailed: 'Batch delete failed',
    batchDeleteSuccessful: 'Batch delete successful',
    saveFailed: 'Save failed',
    saveSuccessful: 'Save successful',
    deleteFailed: 'Delete failed',
    deleteSuccessful: 'Delete successful',
    sureDelete: 'Are you sure to delete?',
    checkDataDeleted: 'Please check the data to be deleted',
    checkDataPaused: 'Please check the data to be paused',
    checkDataEnabled: 'Please check the data to be enabled',
    warning: 'warning',
    success: 'Success',
    error: 'Error',
    info: 'Information',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    UnsavedData: 'There are unsaved records, please save them first!',
    selectTypeTableData: 'Please select type table data',
    NoNewOrModifiedData: 'There is no new or modified data',
    formVerificationFailed: 'Form Verification failed!',
    unableToDeleteQuotation: 'Quotation has been submitted or audited, unable to delete!',
    notNeedPausedQuotation: 'There are paused quotations in the checked data!',
    notNeedEnabledQuotation: 'There are enabled quotations in the checked data!',
    selectedQuotationNotBeenAudited: 'There are unaudited quotations in the checked data!',
    pauseSuccessful: 'Pause successful',
    pauseFailed: 'Pause failed',
    surePauseQuotation: 'Are you sure to pause quotation?',
    sureEnableQuotation: 'Are you sure to enable quotation?',
    enabledSuccessful: 'Enabled successful',
    enabledFailed: 'Enabled failed',
    getDataFailed: 'Get data failed:',
    currentPageNotSaved: 'The current page is not saved. Do you want to continue to query?',
    tips: 'Tips',
    querying: 'Querying',
    saving: 'Saving',
    checkDataCopy: 'Please check the data to copy',
    onlyOneCheck: 'Only one data can be checked for copying',
    beforeAdding: 'Please query and select data before adding',
    notDeleteEnable: 'There are enabled records and cannot be deleted!',
    checkEnableOrPause: 'Please check the data to enable or pause',
    operateSuccessful: 'Operate Successful',
    operateFailed: 'Operate Failed',
    sizeCannotExceed: 'Upload file size cannot exceed 1MB!',
    notMeetRequirements: 'The type of the uploaded file does not meet the requirements!',
    duplicateIconName: 'Duplicate icon name, unable to upload!',
    uploadSuccessful: 'Upload Successful!',
    ErrorIconAddress: 'Error getting icon address',
    checkOneData: 'Check at least one piece of data!',
    notSavedContinueAdding: 'The current page is not saved. Do you want to continue adding?',
    notSavedContinueClose: 'The current page is not saved. Do you want to continue closing?',
    selectPrint: 'Please select a set to print',
    contactAdministrator: 'Unable to delete, please contact system administrator',
    calledNotModify: 'Has been called, cannot modify!',
    productTypeNotModified: 'The product type cannot be modified',
    selectAgreementData: 'Please select agreement table data',
    selectFeeData: 'Please select fee table data',
    feeNamesMustUnique: 'Fee names under the same agreement must be unique',
    elementsMustUnique: 'Business elements of the same fee under the same agreement must be unique',
    typeCalledNotModify: 'Agreement Type has been called, cannot modify!',
    calledNotDelete: 'Has been called, cannot delete!',
    querySucceeded: 'Query succeeded!',
    noMerchantFound: 'No merchant found',
    submittedSuccessfully: 'Submitted successfully!',
    submissionFailure: 'Submission failure!',
    undoSubmissionSuccessful: 'Undo submission successful',
    failedToUndoCommit: 'Failed to undo commit',
    whetherToDelete: 'Whether to delete the selected data',
    whetherToCancel: 'Is the undo operation performed?',
    unableToExport: 'Cannot export without query!',
    checkSingleRecord: 'Please check a single record',
    pleaseCheckRecord: 'Please check Record',
    cannotBeEmpty: 'The search condition cannot be empty',
    noDataExists: 'If no data exists, please re-enter the search criteria',
    selectAData: 'Please select a piece of data',
    pleaseCheck: 'Report path error, please check!',
    pleaseSelectData: 'Please select data',
  },
  messageSetting: {
    messageType: 'Message Type',
    messageName: 'Message Name',
    ediSort: 'EDI Sort',
    serviceAddress: 'Service Address',
    interactiveCompany: 'Interactive Company',
    interactiveMode: 'Interactive Mode',
    interactiveAddressParameters: 'Interactive Address Parameters',
    messageStandard: 'Message Standard',
    application: 'Application',
    transcodingConfiguration: 'Transcoding Configuration',
    companyReferenceConfiguration: 'Company Reference Configuration',
    importAndExportConfiguration: 'Import And Export Configuration',
    codeType: 'Code Type',
    codeName: 'Code Name',
    creator: 'Creator',
    creationTime: 'Creation Time',
    reviser: 'Reviser',
    modificationTime: 'Modification Time',
    fieldCode: 'Field Code',
    fieldName: 'Field Name',
    fieldValue: 'Field Value',
    branchCode: 'Branch Code',
    branchName: 'Branch Name',
    department: 'Department'
  },
  ediType: {
    typeCode: 'Type Code',
    typeName: 'Type Name',
    codeTypeName: 'Code Type Name',
    EDIClass: 'EDI Class',
    creatorName: 'Creator Name',
    createTime: 'Create Time',
    lastModifierName: 'Last Modifier Name',
    lastModifyTime: 'Last Modify Time'
  },
  ediCodeType: {
    codeType: 'Code Type',
    codeName: 'Code Name',
    codeTypeName: 'Code Type Name',
    creatorName: 'Creator Name',
    createTime: 'Create Time',
    lastModifierName: 'Last Modifier Name',
    lastModifyTime: 'Last Modify Time'
  },
  ediApp: {
    appCode: 'APP Code',
    appName: 'APP Name',
    appSign: 'APP Sign',
    creatorName: 'creator Name',
    createTime: 'Create Time',
    lastModifierName: 'Last Modifier Name',
    lastModifyTime: 'Last Modify Time'
  },
  ediInteraction: {
    ediInteractionCode: 'EDI Interaction Code',
    ediInteractionName: 'EDI Interaction Name',
    registerCode: 'Register Code',
    registerName: 'Register Name',
    creatorName: 'Creator Name',
    createTime: 'Create Time',
    importEmail: 'Import Email',
    exportEmail: 'Export Email',
    importURL: 'Import URL',
    exportURL: 'Export URL',
    FTPHost: 'FTP Host',
    FTPPort: 'FTP Port',
    FTPUserName: 'FTP User Name',
    FTPassword: 'FT Password'
  },
  messageDefinition: {
    messageType: 'Message Type',
    EDIGrouping: 'EDI Grouping',
    serviceAddress: 'Service Address',
    messageFormat: 'Message Format',
    interactiveCompany: 'Interactive Company',
    commonCodeConversionSystem: 'Common Code Conversion System',
    interactiveMode: 'Interactive Mode',
    autoSend: 'Auto Send',
    messageName: 'Message Name',
    ediInteraction: 'EDI Interaction',
    ediInteractionCode: 'EDI Interaction Code',
    ediInteractionName: 'EDI InteractionName',
    ediInteractionRegisterCode: 'EDI Interaction Register Code',
    ediInteractionRegisterName: 'EDI Interaction Register Name',
    sender: 'Sender',
    receiver: 'Receiver'
  },
  ReferenceConfiguration: {
    branchRegistrationCode: 'Branch Registration Code',
    branchRegistrationName: 'Branch Registration Name',
    departmentCode: 'Department Code',
    branchDescription: 'Branch Description'
  },
  codeConversion: {
    codeType: 'Code Type',
    codeTypeName: 'Code Type Name',
    conversionRules: 'Conversion Rules',
    defaultCode: 'Default Code',
    internalCode: 'Internal Code',
    internalName: 'Internal Name',
    externalCode: 'External Code',
    externalName: 'External Name'
  },
  //文件上传
  fileUpload: {
    Drag: 'Drag To Here,OR ',
    clickToUpload: 'Click To Upload',
    format: 'Format:word,excel,pdf,jpg,png Limit:10MB.',
    formatCd: 'Format:word,excel,pdf,jpg,png Limit:4MB.',
    fileName: 'File Name',
    documentTypeCode: 'File Type',
    chooseDocumentTypeCode: 'Choose',
    uploadStatus: 'Upload Status',
    uploading: 'Uploading...',
    uploaded: 'Uploaded!',
    uploadFailed: 'Upload failed!',
    fileStatus: 'File Status',
    operation: 'Operation',
    download: 'Download',
    delete: 'Delete',
    formatWm: 'Format:xlsx,xls Limit:10MB.',
    importStatus: 'import Status',
  },
  searchData: {
    invoiceSerialNo: 'Invoice SerialNo',
    invoiceNo: 'InvoiceNo',
    issuedDateFrom: 'IssuedDate From',
    issuedDateTo: 'IssuedDate To',
    invoiceType: 'Invoice Type',
    invoiceTypeMessage: 'Please choose an invoiceType',
  },
  bcInvoice: {
    invoiceSerialNo: 'InvoiceSerial No',
    invoiceNo: 'Invoice No',
    invoiceCode: 'Invoice Code',
    issuedDate: 'Issued Date',
    invoiceType: 'Invoice Type',
    settleCustName: 'SettleCust Name',
    taxpayerIdentificatioNo: 'Taxpayer IdentificatioNo',
    invoiceAmount: 'InvoiceAmount'
  },
  /* 联想控件 */
  associate: {
    permissionName: 'Permission name',
    custAlias: "Consignor Short Name",
    consignorName: "Consignor Name",
    mnemonicCode: "Remember No",
    vesselName: "vesselName",
    voyage: "voyage",
    voyageCode: "voyageCode",
    portNameEn: 'portNameEn',
    portNameCn: "portNameCn",
    countryCode: "countryCode",
    portCode: "portCode",
    typeOfService: "typeOfService",
    codeValue: "codeValue",
    code: 'code',
    fullCN: 'Full Chinese name',
    fullEN: 'Full English name',
    userCode: 'userCode',
    boxTypeSize: 'Box type size'
  }
}
